import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import PouringAnimation from 'components/PouringAnimation/PouringAnimation';
import Text from 'components/Text/Text';
import {useNavigate} from 'react-router-dom';
import './NotFound.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <main className="not-found">
      <div className="not-found__animation">
        <PouringAnimation />
      </div>
      <div className="not-found__text">
        <Text tag="h1" uppercase>
          Error 404: Beer is pouring
        </Text>
        <Text tag="h4">Please wait or come back later.</Text>
        <Button variant="tertiary" onClick={() => navigate(Routes.HOME)}>
          Go Home
        </Button>
      </div>
    </main>
  );
};

export default NotFound;
